export { withStaticHubBreadcrumbs } from './static-hub-breadcrumbs';
